<template>
  <div class="discount-message">
    <span class="discount-message-text" :class="getClass" v-html="getDiscountText"></span>
  </div>
</template>

<script>
export default {
  props: {
    shopType: String
  },
  computed: {
    getDiscountText () {
      const htmlString = `<span style="font-size: 1.2em;color: #FEFB9A"> ${
        this.$bus.currentDiscount === 0 ? '??' : this.$bus.currentDiscount
      }%</span>`
      let currentText = this.$bus.replaceText(
        this.$bus.transify['FESTA_DISCOUNT'],
        htmlString
      )
      if (!currentText) {
        currentText = 'FESTA_DISCOUNT'
      }
      return currentText
    },
    getClass () {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)

      return [
        `discount-message-text-${this.$bus.shopType}`,
        {
          [`text-light-${this.$bus.shopType}`]:
            this.$bus.bigDiscount[index] !== 0 &&
            this.$bus.bigDiscount[index] !== -1
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.discount-message {
  @include flexrc;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  @include px2res(height, 114);
  text-align: center;

  .discount-message-text {
    position: relative;
    @include px2res(padding, 0, 100);
    @include px2res(font-size, 44);
    color: $white;
    font-family: $main-font-family;
    font-style: italic;

    &.discount-message-text-food {
      filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #0b5b9e) drop-shadow(-1px 0px 0px #0b5b9e)
        drop-shadow(0px 1px 0px #0b5b9e) drop-shadow(0px -1px 0px #0b5b9e);
    }

    &.discount-message-text-fishing {
      filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #d3740d) drop-shadow(-1px 0px 0px #d3740d)
        drop-shadow(0px 1px 0px #d3740d) drop-shadow(0px -1px 0px #d3740d);
    }

    &.discount-message-text-shoot {
      filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #cc5815) drop-shadow(-1px 0px 0px #cc5815)
        drop-shadow(0px 1px 0px #cc5815) drop-shadow(0px -1px 0px #cc5815);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/discount-text/index.vue